import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { checkExternalIdExistsPayload } from './create-new-patient-interfaces'
import { Observable, catchError, firstValueFrom, map, throwError } from 'rxjs'

@Injectable({
    providedIn: 'root',
})
export class CreateNewPatientModalService {
    token: string = ''
    headers: HttpHeaders
    orgEntityApiPath = '/api/v1/platform/org-entity'
    userLookUpApiPath = '/api/v1/platform/oauth-user-lookup'
    createNewPatientApiPath = '/api/v1/platform/patient-details/create-patient'
    patientV2API = '/api/v2/platform/patient'
    codeValueByCategoryLookupAPI = '/api/v1/platform/code-value-by-category-lookup/categoryWithValues'
    constructor(private http: HttpClient) {
        this.token = JSON.stringify(localStorage.getItem('access_token'))
        if (this.token) {
            this.token = 'Bearer ' + this.token.slice(1, -1)
        }
        this.headers = new HttpHeaders()
            .set('Content-Type', 'application/json;charset=utf-8')
            .set('Authorization', this.token)
    }
    checkExternalIdAlreadyExistsOrNot(incomingObject: any) {
        return firstValueFrom(
            this.http
                .post(
                    this.orgEntityApiPath + '/checkExternalIdExistsOrNot',
                    incomingObject,
                )
                .pipe((responseData) => {
                    return responseData
                }),
        )
    }
    createNewPatient(orgEntityData: any) {
        const payload = { ...orgEntityData, patientCreationModule: 'CLIENT_PORTAL' };
        return firstValueFrom(
            this.http
                .post(this.patientV2API + '/create', payload)
                .pipe(
                    map((res: any) => {
                        return res
                    }),
                    catchError((error) => this.handleErrorMessage(error)),
                )
        )
    }
    searchByMRN(externalId: string): Observable<any> {
        return this.http
            .get<any>(this.patientV2API + '/mrn-search', {
                params: { externalId: externalId },
            })
            .pipe(
                map((res: any) => {
                    return res
                }),
                catchError((error) => this.handleErrorMessage(error)),
            )
    }
    updatePatientDetails(body: any, orgEntityId: string): Observable<any> {
        return this.http
            .put<any>(this.patientV2API + '/' + orgEntityId, body)
            .pipe(
                map((res: any) => {
                    return res
                }),
                catchError((error) => this.handleErrorMessage(error)),
            )
    }
    mergePatientDetails(body: any, orgEntityId: string): Observable<any> {
        return this.http
            .put<any>(this.patientV2API + '/merge/' + orgEntityId, body)
            .pipe(
                map((res: any) => {
                    return res
                }),
                catchError((error) => this.handleErrorMessage(error)),
            )
    }

    getCodeValuesByCategory(ids: any): Observable<any> {
        return this.http
            .get<any>(
                this.codeValueByCategoryLookupAPI,{params: {ids: ids}}
            )
            .pipe(
                map((res: any) => {
                    return res
                }),
                catchError((error) => this.handleErrorMessage(error)),
            )
    }

    handleErrorMessage(error: any) {
        if (error.status == 403) {
            if (error.error.permission) {
                error.error.message =
                    '"' +
                    error.error.permission.name +
                    '" ' +
                    'Permission not available'
                return throwError(() => error)
            }
        }
        return throwError(() => error)
    }
}
